import { produce } from 'immer';
import { orderBy } from 'lodash';

import { UpdateInternalMarketers } from '../../../actions/marketers/internal/updateInternalMarketers';
import { routeMarketersToKeyMap } from '../../../service/MarketersHelper';
import { Marketer, MarketersState } from '../../../typings/marketers';

export function updateInternalMarketers(state: MarketersState, action: UpdateInternalMarketers): MarketersState {
    return produce(state, draft => {
        draft.marketers = action.marketers;

        if (action.productsSortParams) {
            draft.marketers = orderBy<Marketer>(
                draft.marketers,
                [routeMarketersToKeyMap[action.productsSortParams.key]],
                [action.productsSortParams.direction]
            );
        }

        draft.allMarketers = draft.marketers;
    });
}
